import { computed, ref, watch } from 'vue'
import { request } from '../utils.js'
import useLoading from './loading.js'

export default function useApartments(props) {
  const { isLoading, start, stop } = useLoading()
  const apartments = ref(null)

  async function toPage(page) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })

    start('apartments')
    apartments.value = await request(page)
    stop('apartments')
  }

  async function fetchApartments(options = {}) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })

    start('apartments')
    apartments.value = await request('/apartments', options)
    stop('apartments')
  }

  watch(() => props, async () => {
    const filter = {}

    if (props.city) {
      filter.building_city = props.city
    }

    if (props.maxPrice) {
      filter.max_price = props.maxPrice
    }

    if (props.buildingTypes && props.buildingTypes.length) {
      filter.building_type = props.buildingTypes.join(',')
    }

    if (props.numberOfRooms && props.numberOfRooms.length) {
      filter.number_of_rooms = props.numberOfRooms.join(',')
    }

    await fetchApartments({ filter })
  }, {
    deep: true,
    immediate: true
  })

  return {
    apartments,
    apartmentsIsLoading: computed(() => isLoading('apartments')),
    toPage,
  }
}
